"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadInput = void 0;
var solid_1 = require("@heroicons/react/20/solid");
var outline_1 = require("@heroicons/react/24/outline");
var solid_2 = require("@heroicons/react/24/solid");
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
require("../../../index.css");
var textButton_1 = require("../../action/textButton");
var UploadInput = /** @class */ (function (_super) {
    __extends(UploadInput, _super);
    function UploadInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: "",
        };
        _this.setAsyncState = function (newState) {
            return new Promise(function (resolve) { return _this.setState(newState, resolve); });
        };
        _this.handleOnChange = function (e) {
            if (_this.props.onChange) {
                if (_this.props.type && _this.props.type === "multi") {
                    if (e.target.files && e.target.files.length > 0) {
                        var newFiles = Array.from(e.target.files);
                        var mappedFiles = newFiles.map(function (file) {
                            if (file instanceof File) {
                                var isDuplicate = _this.props.files.upload.some(function (data) {
                                    return (data instanceof Object && data.fileName.name === file.name);
                                });
                                if (isDuplicate)
                                    return null;
                                return { token: (0, uuid_1.v4)(), fileName: file };
                            }
                            return file;
                        });
                        var filteredFiles = mappedFiles.filter(function (file) { return file !== null; });
                        _this.props.onChange({
                            value: filteredFiles,
                            action: "upload",
                        });
                    }
                }
                else {
                    _this.props.onChange(e);
                }
            }
        };
        _this.handleOnRemove = function (item) {
            if (_this.props.type === "multi") {
                if (_this.props.onChange) {
                    _this.props.onChange({ value: item, action: "remove" });
                }
            }
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var error, fileSize, maxFileSize, tempFileNames_1, maxFileSize_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        error = "";
                        if (!this.props.optional) {
                            if (this.props.file) {
                                fileSize = this.props.file.size / 1024 / 1024;
                                maxFileSize = this.props.maxFileSize
                                    ? this.props.maxFileSize
                                    : 30;
                                if (fileSize > maxFileSize) {
                                    error = "File size cannot exceed ".concat(maxFileSize, "MB");
                                }
                            }
                            else if (this.props.files && ((_a = this.props.files.upload) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                tempFileNames_1 = [];
                                maxFileSize_1 = (_b = this.props.maxFileSize) !== null && _b !== void 0 ? _b : 30;
                                this.props.files.upload.map(function (item) {
                                    var fileSize = item.fileName.size / 1024 / 1024;
                                    if (fileSize > maxFileSize_1)
                                        tempFileNames_1.push(item.fileName.name);
                                    return null;
                                });
                                if (tempFileNames_1.length > 0) {
                                    error = "File name: ".concat(tempFileNames_1.join(", "), ", size cannot exceed ").concat(maxFileSize_1, "MB");
                                }
                            }
                            else {
                                error = "Please upload a file";
                            }
                        }
                        return [4 /*yield*/, this.setAsyncState({ error: error })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/, error ? false : true];
                }
            });
        }); };
        _this.handleGetFileExtension = function (file) {
            if (file) {
                var dotIndex = file.name.lastIndexOf(".");
                if (dotIndex > 0 && dotIndex < file.name.length - 1) {
                    return file.name.substring(dotIndex + 1);
                }
                else {
                    throw Error("Invalid file name: no extension found.");
                }
            }
        };
        _this.handleDownloadFile = function (filePath) { return __awaiter(_this, void 0, void 0, function () {
            var res, url, link, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ((_a = this.props.lib) === null || _a === void 0 ? void 0 : _a.axios({
                                method: "get",
                                url: filePath,
                                responseType: "blob",
                            }))];
                    case 1:
                        res = _b.sent();
                        url = URL.createObjectURL(res.data);
                        link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "");
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.renderFileDescription = function () {
            if (_this.props.fileDescription) {
                return _this.props.fileDescription;
            }
            else {
                return "PNG, JPG, JPEG, TIFF up to 30MB";
            }
        };
        _this.renderMultiUploadContent = function (data, type) {
            var uploadList = [];
            data.map(function (eachData, index) {
                var fileName = "";
                var fileSrc = "";
                if (type === "upload" && eachData.fileName instanceof File) {
                    fileName = eachData.fileName.name;
                    fileSrc = URL.createObjectURL(eachData.fileName);
                }
                else if (type === "data" && typeof eachData.fileName === "string") {
                    fileName = eachData.fileName;
                    fileSrc = eachData.fileName;
                }
                uploadList.push(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "relative ".concat(type === "data" ? "mb-4" : "", " mx-2"), key: index },
                        react_1.default.createElement("div", { className: "relative inline-block" },
                            _this.props.hidePreview ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(outline_1.DocumentTextIcon, { className: "mx-auto h-20 max-w-40 object-cover text-gray-300" }),
                                react_1.default.createElement("div", { className: "h-5 w-5 bg-white absolute -top-2.5 -right-2.5 rounded-full" }, !_this.props.disabled && (react_1.default.createElement(solid_2.XCircleIcon, { className: "h-fit w-fit cursor-pointer text-red-400 hover:text-red-600", onClick: function () { return _this.handleOnRemove(eachData); } }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("img", { src: fileSrc, alt: "preview.png", className: "mx-auto h-32 w-auto max-w-40 object-contain rounded-md" }),
                                react_1.default.createElement("div", { className: "h-5 w-5 bg-white absolute -top-2.5 -right-2.5 rounded-full" }, !_this.props.disabled && (react_1.default.createElement(solid_2.XCircleIcon, { className: "h-fit w-fit cursor-pointer text-red-400 hover:text-red-600", onClick: function () { return _this.handleOnRemove(eachData); } }))))),
                            react_1.default.createElement("span", { title: fileName, className: "mb-1.5 text-xs text-gray-500 bg-white" }, fileName.length > 20
                                ? fileName.substring(0, 20) + "..."
                                : fileName),
                            type === "data" && (react_1.default.createElement("div", null,
                                react_1.default.createElement(textButton_1.TextButton, { text: "Download", className: "text-sm text-primary-600", onClick: function () { return _this.handleDownloadFile(fileName); } })))))));
                return null;
            });
            return uploadList;
        };
        _this.renderUploadContent = function () {
            if (_this.props.type === "multi") {
                if (_this.props.files.data.length > 0 ||
                    _this.props.files.upload.length > 0) {
                    return (react_1.default.createElement("div", { className: "space-y-1 text-center" },
                        react_1.default.createElement("div", { className: "flex flex-col" },
                            react_1.default.createElement("div", { className: "flex flex-wrap justify-center gap-4" },
                                _this.renderMultiUploadContent(_this.props.files.data, "data"),
                                _this.renderMultiUploadContent(_this.props.files.upload, "upload")),
                            react_1.default.createElement("div", { className: "flex text-sm text-gray-600 justify-center" },
                                react_1.default.createElement("label", { className: "relative  bg-primary-500 rounded-md font-medium px-4 py-1 text-white ".concat(_this.props.disabled
                                        ? "bg-gray-500 cursor-not-allowed"
                                        : "hover:bg-primary-600 cursor-pointer") },
                                    react_1.default.createElement("span", null, "Add file"),
                                    react_1.default.createElement("input", { id: _this.props.id, name: "file-upload", type: "file", multiple: true, className: "sr-only", accept: _this.props.accept, disabled: _this.props.disabled, onChange: function (e) { return _this.handleOnChange(e); } }))),
                            react_1.default.createElement("p", { className: "text-xs text-gray-500 pt-4" }, _this.renderFileDescription()))));
                }
                else {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(solid_1.FolderPlusIcon, { className: "mx-auto h-24 w-24 text-gray-300" }),
                        react_1.default.createElement("div", { className: "flex text-sm text-gray-600 justify-center" },
                            react_1.default.createElement("label", { className: "relative  bg-primary-500 rounded-md font-medium px-4 py-1 text-white ".concat(_this.props.disabled
                                    ? "bg-gray-500 cursor-not-allowed"
                                    : "hover:bg-primary-600 cursor-pointer") },
                                react_1.default.createElement("span", null, "Upload file"),
                                react_1.default.createElement("input", { id: _this.props.id, name: "file-upload", type: "file", multiple: true, className: "sr-only", accept: _this.props.accept, disabled: _this.props.disabled, onChange: function (e) { return _this.handleOnChange(e); } }))),
                        react_1.default.createElement("p", { className: "text-xs text-gray-500 pt-4 text-center" }, _this.renderFileDescription())));
                }
            }
            else {
                var dataType = "";
                var fileName = "";
                if (typeof _this.props.file === "string" && _this.props.file) {
                    dataType = "url";
                    fileName = _this.props.file;
                }
                else if (_this.props.file instanceof File) {
                    dataType = "file";
                    fileName = _this.props.file.name;
                }
                return (react_1.default.createElement("div", { className: "relative" },
                    react_1.default.createElement("div", { className: "flex flex-col text-center" },
                        !_this.props.hidePreview ? (react_1.default.createElement(react_1.default.Fragment, null, _this.props.file ? (react_1.default.createElement("img", { alt: "", src: dataType === "file"
                                ? URL.createObjectURL(_this.props.file)
                                : _this.props.file, className: "mx-auto h-32 w-auto max-w-40 object-contain rounded-md mb-4" })) : (react_1.default.createElement(outline_1.PhotoIcon, { className: "mx-auto h-24 w-24 text-gray-300" })))) : (react_1.default.createElement(solid_1.FolderPlusIcon, { className: "mx-auto h-24 w-24 text-gray-300" })),
                        react_1.default.createElement("span", { title: fileName, className: "mb-1.5 text-xs text-gray-500 bg-white" }, fileName &&
                            "".concat(fileName.length > 20
                                ? fileName.substring(0, 20) + "..."
                                : fileName)),
                        react_1.default.createElement("div", { className: "flex flex-col justify-center" },
                            dataType === "url" && (react_1.default.createElement(textButton_1.TextButton, { text: "Download", className: "text-sm text-primary-600 mb-4", onClick: function () { return _this.handleDownloadFile(_this.props.file); } })),
                            react_1.default.createElement("div", { className: "flex text-sm text-gray-600 justify-center" },
                                react_1.default.createElement("label", { className: "relative bg-primary-500 rounded-md font-medium px-4 py-1 text-white ".concat(_this.props.disabled
                                        ? "bg-gray-500 cursor-not-allowed"
                                        : "hover:bg-primary-600 cursor-pointer") },
                                    react_1.default.createElement("span", null, "Upload file"),
                                    react_1.default.createElement("input", { id: _this.props.id, name: "file-upload", type: "file", className: "sr-only", accept: _this.props.accept, disabled: _this.props.disabled, onChange: _this.handleOnChange }))),
                            react_1.default.createElement("p", { className: "text-xs text-gray-500 pt-4" }, _this.renderFileDescription())))));
            }
        };
        return _this;
    }
    UploadInput.prototype.render = function () {
        var defaultBorderColor = "border-gray-300";
        var errorBorderColor = "border-red-300";
        return (react_1.default.createElement("div", { className: this.props.className },
            react_1.default.createElement("label", { className: "block text-sm font-medium text-gray-700" },
                this.props.label,
                this.props.labelExtra),
            react_1.default.createElement("div", { className: "".concat(this.state.error ? errorBorderColor : defaultBorderColor, " mt-1 border-2 justify-center px-6 pt-5 pb-6 border-dashed rounded-md bg-white") }, this.renderUploadContent()),
            react_1.default.createElement("span", { className: "text-red-500 text-sm" }, this.state.error)));
    };
    return UploadInput;
}(react_1.Component));
exports.UploadInput = UploadInput;
//# sourceMappingURL=index.js.map